(function() { window.GUID_45d12f5e_2d41_4118_afdd_59b3bf7d0cdc = { getGuid: function() { return "45d12f5e-2d41-4118-afdd-59b3bf7d0cdc"; } }; })();
var EditEncounterOpp;
(function (EditEncounterOpp) {
    var desktop;
    (function (desktop) {
        CS.FormReady(function (formId) {
            if (formId == "EditSchedules") {
                if (document.HomeId != undefined) {
                    document.HomeId.SelectionChange = function () {
                        if (this.SelectedItem != null) {
                            $('#PlaceId').control().SetValue({ value: this.SelectedItem.value.placeId });
                        }
                    };
                }
                /* en changeant de bracket, on vide les noms des équipes car ils ne seront pas dispo dans le drop down.
    
                 * #############################################################*/
                //$("#FlowBlockId").controlIsLoaded<CompuSport.Controls.DropDown>(function (dropdown) {
                //    dropdown.$DropDown.on('change', function (dropdown) {                  
                //        $('#HomeId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //        $('#AwayId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //    });
                //});
            }
        });
    })(desktop = EditEncounterOpp.desktop || (EditEncounterOpp.desktop = {}));
})(EditEncounterOpp || (EditEncounterOpp = {}));

//# sourceMappingURL=EditEncounterOpp.desktop.js.map
